import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthService from './AuthService';

export default function PrivateRoute() {
  const location = useLocation();
  if (!AuthService.isTokenValid()) {
    AuthService.setPostLoginRedirectPath(`${location.pathname}${location.search}`);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
}
